import { JurisdictionId } from '../../types/jurisdiction';
import { SET_ALLOWED_JURISDICTIONS, SET_JURISDICTION } from './types';

export function setJurisdiction(id: JurisdictionId) {
  return {
    type: SET_JURISDICTION,
    payload: id,
  };
}

export function setAllowedJurisdictions(ids: JurisdictionId[]) {
  return {
    type: SET_ALLOWED_JURISDICTIONS,
    payload: ids,
  };
}
